"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _formElements = require("@evidation/form-elements");

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _progressbar = _interopRequireDefault(require("./components/progressbar"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NavigationContainer = _styledComponents["default"].div.withConfig({
  displayName: "BillboardNavigation__NavigationContainer",
  componentId: "sc-1rqn5w9-0"
})(["margin-top:20px;margin-bottom:60px;"]);

var BillboardNavigation = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(BillboardNavigation, _React$PureComponent);

  var _super = _createSuper(BillboardNavigation);

  function BillboardNavigation() {
    var _this;

    (0, _classCallCheck2["default"])(this, BillboardNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClickNext", function () {
      return _this.props.onChangePage(+1);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClickPrevious", function () {
      return _this.props.onChangePage(-1);
    });
    return _this;
  }

  (0, _createClass2["default"])(BillboardNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          valid = _this$props.valid,
          pristine = _this$props.pristine,
          submitting = _this$props.submitting,
          submitFailed = _this$props.submitFailed,
          submitSucceeded = _this$props.submitSucceeded,
          _this$props$total = _this$props.total,
          total = _this$props$total === void 0 ? 0 : _this$props$total,
          _this$props$page = _this$props.page,
          page = _this$props$page === void 0 ? 0 : _this$props$page,
          _this$props$initialVa = _this$props.initialValues,
          initialValues = _this$props$initialVa === void 0 ? {} : _this$props$initialVa,
          _this$props$progress = _this$props.progress,
          progress = _this$props$progress === void 0 ? false : _this$props$progress,
          _this$props$enrollmen = _this$props.enrollment_appx_time,
          enrollment_appx_time = _this$props$enrollmen === void 0 ? 10 : _this$props$enrollmen,
          _this$props$submit_la = _this$props.submit_label,
          submit_label = _this$props$submit_la === void 0 ? "Submit" : _this$props$submit_la,
          _this$props$next_labe = _this$props.next_label,
          next_label = _this$props$next_labe === void 0 ? "Continue" : _this$props$next_labe,
          _this$props$back_labe = _this$props.back_label,
          back_label = _this$props$back_labe === void 0 ? "Go Back" : _this$props$back_labe,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$button_sp = _this$props.button_spacing,
          button_spacing = _this$props$button_sp === void 0 ? 10 : _this$props$button_sp,
          children = _this$props.children,
          buttonStyle = _this$props.buttonStyle,
          _this$props$hideSubmi = _this$props.hideSubmit,
          hideSubmit = _this$props$hideSubmi === void 0 ? false : _this$props$hideSubmi,
          _this$props$forceShow = _this$props.forceShowNext,
          forceShowNext = _this$props$forceShow === void 0 ? false : _this$props$forceShow,
          _this$props$forceShow2 = _this$props.forceShowPrevious,
          forceShowPrevious = _this$props$forceShow2 === void 0 ? false : _this$props$forceShow2;
      var progressRemaining = 0;
      var calculatedProgress = progress; // Logic to determine if submit should be deactivated
      // in this instance we are checking to see if we have initial values defined
      // as If we have already populated the form (for CRF ONLY), it is ready to be submitted
      // most other cases do not require this.

      var beforeSubmit = !submitFailed && !submitSucceeded;
      var disableSubmit = !valid && beforeSubmit || submitting || _lodash["default"].isEmpty(initialValues) && pristine;

      if (progress) {
        if (total >= 1) {
          progressRemaining = 100 - progress;
          calculatedProgress = calculatedProgress + progressRemaining / total * page - 5;
        }
      } else {
        calculatedProgress = false;
      }

      var multiplePages = total > 0;
      var notLastPage = page < total;
      var notFirstPage = page > 0;
      var showSubmit = !hideSubmit && page === total;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(NavigationContainer, {
        style: style
      }, showSubmit && /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
        isLoading: submitting,
        buttonStyle: buttonStyle,
        id: "t-submit_button",
        "data-test-id": "submit_button",
        type: "submit",
        disabled: disableSubmit,
        style: {
          marginBottom: button_spacing
        }
      }, submit_label), (multiplePages && notLastPage || forceShowNext) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
        buttonStyle: buttonStyle,
        id: "t-next_button",
        disabled: !valid || page === total && !forceShowNext,
        onClick: this.handleClickNext,
        style: {
          marginBottom: button_spacing
        }
      }, next_label)), (notFirstPage || forceShowPrevious) && /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
        buttonStyle: buttonStyle,
        id: "t-previous_button",
        disabled: page === 0 && !forceShowPrevious,
        onClick: this.handleClickPrevious,
        style: {
          marginBottom: button_spacing
        }
      }, back_label), children && children), calculatedProgress && /*#__PURE__*/_react["default"].createElement(_progressbar["default"], {
        progress: calculatedProgress,
        enrollment_time: enrollment_appx_time
      }));
    }
  }]);
  return BillboardNavigation;
}(_react["default"].PureComponent);

BillboardNavigation.defaultProps = {
  buttonStyle: "achievement"
};
BillboardNavigation.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.element, _propTypes.func]),
  total: _propTypes.number,
  page: _propTypes.number,
  initialValues: _propTypes.object,
  progress: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.number]),
  enrollment_appx_time: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  submit_label: _propTypes.string,
  next_label: _propTypes.string,
  back_label: _propTypes.string,
  style: _propTypes.object,
  button_spacing: _propTypes.number,
  buttonStyle: _propTypes.string,
  hideSubmit: _propTypes.bool,
  forceShowNext: _propTypes.bool,
  forceShowPrevious: _propTypes.bool
};
var _default = BillboardNavigation;
exports["default"] = _default;